module.exports = __webpack_public_path__ + "static/media/silence.241ac5d2.mp3";